import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NotifierService } from 'angular-notifier';
import { Message } from 'src/app/core/class/message';
import { CommonService } from 'src/app/core/services/common.service';
import { BaseComponent } from 'src/app/shared/components/base/base.component';

@Component({

  selector: 'app-labor-utilization-report',
  templateUrl: './labor-utilization-report.component.html',
  styleUrls: ['./labor-utilization-report.component.scss']
})
export class LaborUtilizationReportComponent extends BaseComponent implements OnInit, OnDestroy {
  isInforTab = 0;

  constructor(
    public commonService: CommonService,
    public message: Message,
    private notifier: NotifierService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
  ) {
    super(commonService, message);
    this.notifier = notifier;
  }

  ngOnInit() {
    this.activatedRoute
      .queryParams
      .subscribe(params => {
        if(params.currentTab){
          this.isInforTab = params.currentTab
        }
      });
  }

  changeTabSelected($event: any){
    this.isInforTab = $event
    const url = new URL(window.location.href);
    url.searchParams.set('currentTab', $event);
    window.history.pushState({}, '', url.toString());
  }

  ngOnDestroy(){

  }
}
